import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';


class ScrollItem__BlockCards extends ScrollItem__BlockDefault {
    _call;
    _slider;
    _yOld = 0;
    _posOld = {x: 0, y: 0};

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if (!GetBy.class('__holder', __link)[0]) return;

        this.container = __link;
        this.holder = GetBy.class('__holder', this.container)[0];
        this._slider = new InfiniteScroll(InfiniteScroll.AXIS_X, {
            domResize: this.container,
            appendContainer: this.holder,
            container: this.container,
            multiplicator: 1,
            minSpeed: 2,
            inverted: false,
            gap: 0,
            hasVirtuaScroll: false,
            hasInteraction: true
        });

        this._call = () => this.loop();
        this._onEnter = () => {
            if (this._slider) this._slider.options.minSpeed = 0;
        };
        this._onLeave = () => {
            if (this._slider) this._slider.options.minSpeed = 2;
        };

        this.onShow = () => {
            this._slider.show();
            this._slider.enabled = true;
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            this._slider.enabled = false;
            gsap.ticker.remove(this._call);
        };

        this.holder.addEventListener('mouseenter', this._onEnter);
        this.holder.addEventListener('mouseleave', this._onLeave);
    }

    resize(w, h) {
        super.resize(w, h);
        if (this._slider) this._slider.resize();
    }

    loop() {
        if (this._slider) {
            this._slider.check({ deltaY: (-(this.y - this._yOld)*.2) });
            this._yOld = this.y;
            this._slider.loop();
        }
    }

    dispose() {
        gsap.ticker.remove(this._call);

        if (this.holder) {
            this.holder.removeEventListener('mouseenter', this._onEnter);
            this.holder.removeEventListener('mouseleave', this._onLeave);
        }

        if (this._slider) {
            this._slider.enabled = false;
            this._slider.dispose();
            this._slider = null;
        }

        this.onShow = () => {};
        this.onHide = () => {};
        this._call = null;
        this._onEnter = null;
        this._onLeave = null;
        this.holder = null;
        this.container = null;

        super.dispose();
    }
}

Scroll._registerClass('BlockCards', ScrollItem__BlockCards);
